export class BlockApp {
    id: number;
    initialDate: Date;
    endDate: Date;
    description: string;
    domain: number;
    token: string;
    errorCode: {
        message: string,
        code: string
    };

} 